export default __webpack_public_path__ + "static/WMATIC-910e1faf70490b18fd2f192d54244236.png";